import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import Footer from "../Components/common/footer";
import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import PageDocsTab, { createDocsTab } from "../Components/DocPage/new-tab/page-docs-tab";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import AddIcon from "../assets/Add-icon-gold.svg";
import AddCaseLoanModal from "../Components/CaseLoansDashboard/AddCaseLoanModal";
import useGetLoansPanels from "../Components/CaseLoansDashboard/hooks/useGetLoansPanels";
import LoansAllPage from "../Components/CaseLoansDashboard/new-case-loans-tab/all-tab-loans";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import "../Components/CaseLoansDashboard/CaseLoansDashboard.css";

const PageContent = ({ currentPage, loans, pageIcon, pageName }) => {
  const getFilteredLoans = () => {
    if (currentPage === "all") {
      return loans.loans;
    }

    // Check if currentPage matches a specific defendant ID
    if (currentPage?.startsWith("loan_")) {
      const defendantId = parseInt(currentPage.replace("loan_", ""));
      return loans?.loans?.filter((loan) => loan?.id === defendantId);
    }

    return loans;
  };
  const filteredLoans = getFilteredLoans();

  switch (currentPage) {
    case "docs":
      return (
        <PageDocsTab
          key={`${getClientId()}-${getCaseId()}`}
          pageId={17}
          pageName={pageName}
          pageIcon={pageIcon}
        />
      );
    case "all":
      return (
        <LoansAllPage
          loans={filteredLoans}
          updateCaseLoansPanels={loans?.updateCaseLoansPanels}
          pageIcon={pageIcon}
        />
      );
    default:
      return (
        <LoansAllPage
          loans={filteredLoans}
          updateCaseLoansPanels={loans?.updateCaseLoansPanels}
          pageIcon={pageIcon}
        />
      );
  }
};

const NewCaseLoansPage = () => {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const dispatch = useDispatch();
  const [pageObject, setPageObject] = useState(null);
  const caseId = getCaseId();

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 17).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 17, dispatch);
  }, [dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const [currentPage, setCurrentPage] = useState("all");
  const [showAddPopup, setShowAddPopup] = useState(false);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);
  const docsTabs = useMemo(
    () => [createDocsTab(() => handlePageChange("docs"))],
    [handlePageChange]
  );
  const attachmentTabs = usePageAttachmentTabs(17, docsTabs);
  const loansPanelsObj = useGetLoansPanels();

  const mainTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });

    if (loansPanelsObj?.loans?.length > 0) {
      loansPanelsObj?.loans?.forEach((loan) => {
        let label = "";

        label = `${loan?.lending_company_contact?.name || "Loan Company Name"}`;

        tabs.push({
          id: `loan_${loan?.id}`,
          label: label,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`loan_${loan?.id}`),
          leftHand: false,
        });
      });
    }

    return tabs;
  }, [handlePageChange, loansPanelsObj]);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "create_caseloan",
      label: "Case Loan",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => {
        setShowAddPopup(true);
      },
      leftHand: true,
      span: (
        <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={AddIcon} />
        </span>
      ),
    });

    return tabs;
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName={"40"} />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            {/* <div
              className="smart-responsive-tabs-wrapper"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "25px",
                position: "relative",
                gap: "15px",
                // justifyContent: "space-between",
              }}
            >
              <div
                className="specialty-section"
                style={{
                  width: "50%",
                }}
              >
                <NewChangesTabs
                  currentTab={currentPage}
                  tabsData={mainTabs}
                  height={25}
                  labelClass=" justify-content-start pe-2"
                  // widthTab={true}
                  // mainContainerClass="pe-0"
                />
              </div>
              <div className="add-tabs-section">
                <MoreChangesTab
                  labelClass="ps-2 pe-2"
                  handlePage={currentPage}
                  tabsData={buttonTabs}
                  height={25}
                  popupTabs={true}
                />
              </div>
            </div> */}
            <SmartResponsiveTabsContainer
              isEmpty={loansPanelsObj?.loans?.length === 0}
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={[]}
              addTab={buttonTabs}
              photoTab={attachmentTabs}
              photoTabControlled={true}
              handlePageChange={handlePageChange}
              viewType={""}
            />

            <PageContent
              currentPage={currentPage}
              loans={loansPanelsObj}
              pageIcon={pageObject?.page_icon}
              pageName={pageObject?.name}
            />

            <NotesSectionDashboard pageName={"Loans"} />
          </div>
        </div>
      </div>
      <Footer />

      {showAddPopup && (
        <AddCaseLoanModal
          show={showAddPopup}
          handleClose={() => {
            setShowAddPopup(false);
          }}
          updateLoanStates={loansPanelsObj.updateCaseLoansPanels}
        />
      )}
    </>
  );
};

export default NewCaseLoansPage;
